import { handleApiError } from 'BreetHelpers';
import {
	apiSlice,
	logUserOut,
	openModal,
	selectFcmToken,
	useAppDispatch,
	useAppSelector,
	useLogoutMutation,
	useRemoveFCMTokenMutation,
} from 'BreetRedux';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

export const useAuthApi = (lastVisited?: string) => {
	const dispatch = useAppDispatch();
	const fcmToken = useAppSelector(selectFcmToken) as unknown as string;

	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const [logout] = useLogoutMutation();
	const [removeFCMToken] = useRemoveFCMTokenMutation();

	const promptLogout = useCallback(() => {
		dispatch(openModal({ id: 'logout', hideCloseButton: true }));
	}, [dispatch]);

	const handleLogoutFinally = useCallback(() => {
		dispatch(logUserOut(lastVisited));

		setLoading(false);

		dispatch(apiSlice.internalActions.onOnline());

		navigate('/login', { replace: true })?.catch(console.error);
	}, [dispatch, lastVisited, navigate]);

	const onLogout = useCallback(() => {
		if (loading) return;
		setLoading(true);
		const removePromise = fcmToken ? removeFCMToken({ token: fcmToken }).unwrap().catch(handleApiError) : Promise.resolve();

		removePromise.catch(handleApiError).finally(() => {
			logout().unwrap().catch(handleApiError).finally(handleLogoutFinally);
		});
	}, [loading, logout, fcmToken, removeFCMToken, handleLogoutFinally]);

	return {
		onLogout,
		isLoading: loading,
		promptLogout,
	};
};
